import React from "react";
import { MtData } from "../../utils/types";

interface MtMessageDetailsModalProps {
  selectedRow: MtData | null;
  setSelectedRow: (row: MtData | null) => void;
}

const MtMessageDetailsModal: React.FC<MtMessageDetailsModalProps> = ({
  selectedRow,
  setSelectedRow,
}) => {
  if (!selectedRow) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-full sm:max-w-3xl w-full max-h-[80vh] overflow-y-auto">
        <div className="p-4 sm:p-6 border-b border-gray-200 flex justify-between items-center">
          <h2 className="text-lg sm:text-xl font-semibold text-gray-800">
            Message Conversation Details
          </h2>
          <button
            onClick={() => setSelectedRow(null)}
            className="text-gray-500 hover:text-gray-700 text-2xl font-light w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100"
          >
            ×
          </button>
        </div>

        <div className="p-4 sm:p-6 space-y-6">
          {/* User Info */}
          <div className="bg-gray-50 rounded-lg p-4">
            <h3 className="font-semibold text-gray-800 mb-2">
              Contact Information
            </h3>
            <div className="grid grid-cols-2 gap-4 text-sm">
              <div>
                <span className="text-gray-600">Phone Number:</span>
                <span className="ml-2 font-mono">{selectedRow.msisdn}</span>
              </div>
              <div>
                <span className="text-gray-600">Network:</span>
                <span
                  className={`ml-2 px-2 py-1 rounded text-xs font-semibold ${
                    selectedRow.network === "MTN"
                      ? "bg-yellow-100 text-yellow-800"
                      : selectedRow.network === "Airtel"
                      ? "bg-red-100 text-red-800"
                      : selectedRow.network === "Glo"
                      ? "bg-green-100 text-green-800"
                      : selectedRow.network === "9Mobile"
                      ? "bg-purple-100 text-purple-800"
                      : "bg-gray-100 text-gray-800"
                  }`}
                >
                  {selectedRow.network}
                </span>
              </div>
            </div>
          </div>

          {/* Conversation */}
          <div className="space-y-4">
            <h3 className="font-semibold text-gray-800">Message Exchange</h3>

            {/* User Message (MO) */}
            <div className="flex justify-start">
              <div className="bg-green-100 rounded-lg p-3 max-w-[80%]">
                <div className="text-xs text-green-600 font-semibold mb-1">
                  Mobile Originated (MO)
                </div>
                <p className="text-sm text-gray-800">{selectedRow.mo}</p>
              </div>
            </div>

            {/* System Response (MT) */}
            <div className="flex justify-end">
              <div className="bg-blue-100 rounded-lg p-3 max-w-[80%]">
                <div className="text-xs text-blue-600 font-semibold mb-1">
                  Mobile Terminated (MT) Response
                </div>
                <p className="text-sm text-gray-800">
                  {selectedRow.mt_response}
                </p>
              </div>
            </div>
          </div>

          {/* Timestamp */}
          <div className="text-xs text-gray-500 text-center border-t pt-4">
            Conversation occurred on{" "}
            {new Date(selectedRow.created_at).toLocaleString()}
          </div>
        </div>

        <div className="p-4 sm:p-6 border-t border-gray-200 flex justify-end">
          <button
            onClick={() => setSelectedRow(null)}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200 font-medium text-sm"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default MtMessageDetailsModal;
